/** @module Auth0Client */
/* eslint-disable import/extensions */
import Auth0Constants from './auth0-constants.mjs';
import CookieHelper from './auth0-cookie-helper.mjs';

class Auth0Client {
  constructor(clientIdOrClientOptions, clientSecret = null) {
    if (!clientIdOrClientOptions) {
      console.log('Auth0Client.constructor() clientIdOrClientOptions is not specified');
      throw new Error('Error initializing Auth0Client, clientIdOrClientOptions must be specified');
    }

    if (typeof clientIdOrClientOptions === 'string') {
      this._clientId = clientIdOrClientOptions;

      if (clientSecret) {
        this._clientSecret = clientSecret;
      }
    } else {
      // as options object
      this._clientId = clientIdOrClientOptions.clientId;
      if (clientIdOrClientOptions.clientSecret) {
        this._clientSecret = clientIdOrClientOptions.clientSecret;
      }
    }
  }

  get clientId() {
    return this._clientId;
  }

  get clientSecret() {
    return this._clientSecret;
  }

  cleanAuth0State = () => {
    CookieHelper.deleteCookie(Auth0Constants.SECONDARY_TOKENS_KEY);
    CookieHelper.deleteCookie(Auth0Constants.AUTH0_IS_AUTHENTICATED);
    CookieHelper.deleteCookie(Auth0Constants.AUTH_COOKIE);
    if (this.clientId) {
      CookieHelper.deleteCookie(Auth0Constants.AUTH0_IS_AUTHENTICATED_CLIENT(this.clientId));
      CookieHelper.deleteCookie(Auth0Constants.AUTH0_IS_AUTHENTICATED_LEGACY_CLIENT(this.clientId));
    }
  };
}

export default Auth0Client;
